var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 387936497"
  }, /*#__PURE__*/React.createElement("g", {
    id: "in"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7155 17.4492V30H13.5172V17.4492H14.7155ZM15.2327 13.1226C15.2327 13.274 15.199 13.417 15.1317 13.5515C15.0729 13.6776 14.993 13.7912 14.8921 13.8921C14.7912 13.993 14.6734 14.0729 14.5389 14.1317C14.4043 14.1906 14.2614 14.22 14.11 14.22C13.9587 14.22 13.8157 14.1906 13.6811 14.1317C13.5466 14.0729 13.4289 13.993 13.328 13.8921C13.227 13.7912 13.1472 13.6776 13.0883 13.5515C13.0294 13.417 13 13.274 13 13.1226C13 12.9713 13.0294 12.8283 13.0883 12.6938C13.1472 12.5508 13.227 12.4289 13.328 12.328C13.4289 12.227 13.5466 12.1472 13.6811 12.0883C13.8157 12.0294 13.9587 12 14.11 12C14.2614 12 14.4043 12.0294 14.5389 12.0883C14.6734 12.1472 14.7912 12.227 14.8921 12.328C14.993 12.4289 15.0729 12.5508 15.1317 12.6938C15.199 12.8283 15.2327 12.9713 15.2327 13.1226Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1434 19.644C20.7236 18.9208 21.3922 18.3406 22.149 17.9033C22.9142 17.466 23.7636 17.2474 24.697 17.2474C25.3866 17.2474 25.992 17.3567 26.5134 17.5753C27.0432 17.794 27.4805 18.1093 27.8252 18.5214C28.17 18.9334 28.4307 19.4296 28.6073 20.0098C28.7839 20.59 28.8722 21.246 28.8722 21.9776V30H27.6613V21.9776C27.6613 20.8003 27.3922 19.8795 26.854 19.2151C26.3158 18.5424 25.4959 18.206 24.3943 18.206C23.5786 18.206 22.8133 18.4163 22.0985 18.8367C21.3922 19.2488 20.7615 19.8248 20.2065 20.5648V30H18.9955V17.4492H19.6641C19.8743 17.4492 19.9962 17.5543 20.0299 17.7645L20.1434 19.644Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 387936491"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 4648",
    cx: 21,
    cy: 21,
    r: 20.5,
    stroke: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedinIcon.2a605fab5d0bcedf1cc03f2378fd9d16.svg";
export { ForwardRef as ReactComponent };